import styled from 'styled-components';

// todo: refactor only what is needed
const SelectWrapper = styled.div`
    position: relative;
    div {
        pointer-events: auto;

    }

   .dropdownCreatable {
        box-shadow: none !important;
        border-radius: 0 !important;
        outline: none !important;
        -webkit-appearance: none !important;
        -moz-appearance: none !important;
        appearance: none !important;
        height: 3.125rem;
        width: 100%;
        border: 0.063rem solid ${props => props.isDisabled ? ' #AAAAAA' : props.theme.color};
        font-size: 1rem;
        box-sizing: border-box;
        -webkit-appearance: none;
        -webkit-border-radius: 0px;
        opacity: 1; /* required on iOS */
        padding: 0 1.25rem;
    }

    .dropdownCreatable .isdisabled .react-select--is-disabled > .react-select__control .react-select__control--is-disabled > .react-select__indicators > .react-select__indicator .react-select__dropdown-indicator {
        background-color: red;
    }

    .react-select__menu {
        left:0;
    }

    .react-select__menu-list {
        overflow-x: hidden;
        margin: 0 0 !important;
    
    }
   
    .react-select__option {
         font-size: 1rem;
        font-family: arial;
        margin:0 0 !important;
    }

    .react-select__control {
        border: 0;
        font-size: 1rem;
        box-shadow: 0 0;
        font-family: arial;
        margin-right:0 !important;

    }
    
    .react-select__control:hover {
        border: 0;
    }
    
    .react-select__control--is-disabled {
        background-color: transparent;
       
    }
    .react-select__control.react-select__control--is-disabled > .react-select__indicators > .react-select__indicator.react-select__dropdown-indicator > img {
        height: 20px;
        width: 20px;
        opacity: 0.3;
    }
    .react-select__dropdown-indicator img {
        height: 28px; 
        margin: 0 0 !important;
        width:28px;
        font-size: 1rem;
        box-shadow: 0 0;
        font-family: arial;
    }
    .react-select__value-container {
        height: 45px;
        line-height: 45px;
        margin:0 0 !important;

    }
    .react-select__placeholder{
        margin:0 0 !important;
    }
    .react-select__single-value{
        color: #000000;
    }
`;

export default SelectWrapper;
